import PolygonBase from './PolygonBase';
import shapeIcon from '../assets/icons/shapePreparation.svg';
import { svgToIcon } from '../utils/svg';

const HEIGHT_FACTOR = 0.5;

class ShapePreparation extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeIcon);
  }

  static defaultHeight() {
    return this.defaultWidth() * HEIGHT_FACTOR;
  }

  static pathString() {
    const s = 1 / 3;
    return `
      M -0.5 0.0
      L ${-s} -0.5
      L ${s} -0.5
      L 0.5 0.0
      L ${s} 0.5
      L ${-s} 0.5
      L -0.5 0.0
      Z
    `;
  }
}

export default ShapePreparation;
